import api from '../../services/api'
import { EncuestaBajaItem, ReclamoClienteItem } from '../inicioKpis'

export interface IRelevamientoRutina {
    datos: DatoRelevamientoRutina[];
}

export interface IResumenFiscalizacionPSResponse {
    datos: ResumenFiscalizacionPS;
}

export interface DatoRelevamientoRutina {
    rel_codigo: number;
    rel_numero: string;
}

export interface ReclamoUltimoTrimestre {
    clasificacion_reclamo: string;
    gravedad: string;
    cantidad: number;
}

export interface CalificacionVisitaPS {
    evaluacion_id: number | null;
    fecha_visita: string | null;
    calificacion: string | null;
}

export interface PromedioEncuestaPS {
    promedio_calificacion: string | null;
}

export interface ResumenFiscalizacionPS {
    relevamientos: DatoRelevamientoRutina[];
    reclamos_ultimo_trimestre: ReclamoUltimoTrimestre[];
    calificacion_visita: CalificacionVisitaPS;
    promedio_encuesta: PromedioEncuestaPS;
    encuestas_bajas?: EncuestaBajaItem[];
    reclamos_clientes?: ReclamoClienteItem[];
}

interface IRelevamientoRutinaGET {
    ps_codigo:string;
}

const RELEVAMIENTO_RUTINA = '/punto_servicio/relevamientos/'
const RESUMEN_FISCALIZACION_PS = '/punto_servicio/resumen_fiscalizacion/'
const config = {
    headers: {
        'Content-Type': 'application/json'
    }
}

export async function getRelevamientoRutina(ps_codigo:IRelevamientoRutinaGET) {
    const { data } = await api.get<IRelevamientoRutina>(`${RELEVAMIENTO_RUTINA}${encodeURIComponent(ps_codigo.ps_codigo)}`, config)
    return data.datos;
}

export async function getResumenFiscalizacionPS(ps_codigo:IRelevamientoRutinaGET) {
    const { data } = await api.get<IResumenFiscalizacionPSResponse>(`${RESUMEN_FISCALIZACION_PS}${encodeURIComponent(ps_codigo.ps_codigo)}`, config)
    return data.datos;
}
